import { useMemo } from 'react';
import { useStripePortal } from './useStripePortal';
import useUser from './useUser';
import { useUserPlans } from './useUserPlans';

export function useSubscriptionRecovery() {
  const { status, name: planName, plans } = useUserPlans();
  const { data: user } = useUser();
  const { plan } = user.billing;
  const { data: stripePortal } = useStripePortal();
  const stripePortalUrl = stripePortal?.url;

  const planInterval = useMemo(() => {
    let planInterval = '';
    if (typeof plans !== 'undefined') {
      plans.forEach((p) => {
        Object.values(p).forEach((value) => {
          if (value.id === plan) {
            planInterval = value.interval;
          }
        });
      });
    }
    if (planInterval.toLowerCase() === 'year') {
      return 'yearly';
    }
    if (planInterval.toLowerCase() === 'month') {
      return 'monthly';
    }
    return planInterval;
  }, [plans, plan]);

  return {
    status,
    planName,
    planInterval,
    stripePortalUrl,
    isPastDue: user.billing.status === 'past_due',
  };
}
